import AboutUsIconFrame0 from "./AboutUsIconFrame0"
import AboutUsIconFrame1 from "./AboutUsIconFrame1"
import DirectionsRunArmsUpIcon from "./DirectionRunArmsUpIcon"
import DirectionsWalkArmsUpIcon from "./DirectionsWalkArmsUpIcon"

interface Props {
    frame: 0 | 1 | 2 | 3
    animationClass0: string,
    animationClass1: string
}

const offsetSimpleGuy: React.CSSProperties = {
    // position: "absolute",
    // backgroundColor:'green',
    // top: 40,
    // left: 15
}

export default function ({ frame, animationClass0, animationClass1 }: Props) {
    return (
        <>
            {frame === 0 && (
                <AboutUsIconFrame0 />
            )}
            {frame === 1 && (
                <div
                    style={{
                        position: "absolute",
                        top: -20,
                        left: -34
                    }}
                >
                    <AboutUsIconFrame1 />
                </div>
            )}
            {frame === 2 && (
                <div style={offsetSimpleGuy} className={animationClass1}>
                    <DirectionsWalkArmsUpIcon />
                </div>

            )}
            {frame === 3 && (
                <div style={offsetSimpleGuy} className={animationClass1}>
                    <DirectionsRunArmsUpIcon />

                </div>
            )}
        </>
    )
}

